export const GET_LOGIN_REQUEST_USER ="GET_LOGIN_REQUEST_USER"
export const GET_LOGIN_REQUEST_USER_SUCCESS ="GET_LOGIN_REQUEST_USER_SUCCESS"
export const GET_LOGIN_REQUEST_USER_FAILURE ="GET_LOGIN_REQUEST_USER_FAILURE"


//////////////////////////////SignUp candidtate and employer//////////////////////////////////////////


export const GET_SIGNUP_REQUEST_USER = "GET_SIGNUP_REQUEST_USER"
export const GET_SIGNUP_REQUEST_USER_SUCCESS ="GET_SIGNUP_REQUEST_USER_SUCCESS"
export const GET_SIGNUP_REQUEST_USER_FAILURE ="GET_SIGNUP_REQUEST_USER_FAILURE"